import React from "react"

/**
 * A React component that renders a home SVG icon.
 *
 * @param {object} props - The component props.
 * @param {string} props.color - The color of the SVG icon.
 * @return {JSX.Element} The rendered SVG element.
 */
export const FlagSvg = (props: { color: string }): JSX.Element => {
    const { color } = props
    return (
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_2352_17151)">
          <path
            d="M3.71328 2.96211C3.71328 3.38442 3.52558 3.70702 3.15019 3.92991V15.0684C3.15019 15.1447 3.12233 15.2107 3.06661 15.2664C3.01089 15.3221 2.9449 15.35 2.86865 15.35H2.30556C2.22931 15.35 2.16333 15.3221 2.10761 15.2664C2.05188 15.2107 2.02402 15.1447 2.02402 15.0684V3.92991C1.64863 3.70702 1.46094 3.38442 1.46094 2.96211C1.46094 2.65124 1.57091 2.38582 1.79087 2.16587C2.01082 1.94591 2.27624 1.83594 2.58711 1.83594C2.89798 1.83594 3.16339 1.94591 3.38334 2.16587C3.6033 2.38582 3.71328 2.65124 3.71328 2.96211ZM16.6642 3.52519V10.2382C16.6642 10.3849 16.6276 10.4978 16.5542 10.5769C16.4809 10.6561 16.3651 10.7368 16.2067 10.8189C14.9456 11.4993 13.8635 11.8395 12.9602 11.8395C12.6024 11.8395 12.2402 11.775 11.8736 11.6459C11.507 11.5169 11.1888 11.3761 10.919 11.2236C10.6492 11.0711 10.3105 10.9303 9.90281 10.8013C9.49516 10.6723 9.07724 10.6077 8.64907 10.6077C7.5229 10.6077 6.16211 11.0359 4.5667 11.8923C4.46699 11.9451 4.37021 11.9715 4.27636 11.9715C4.12386 11.9715 3.99189 11.9157 3.88044 11.8043C3.769 11.6929 3.71328 11.5609 3.71328 11.4084V4.88011C3.71328 4.69242 3.80419 4.53112 3.98602 4.39621C4.1092 4.3141 4.34088 4.18799 4.68108 4.01789C6.06533 3.31403 7.30001 2.96211 8.38512 2.96211C9.01272 2.96211 9.59927 3.04716 10.1448 3.21725C10.6902 3.38735 11.3325 3.64543 12.0716 3.9915C12.2945 4.10294 12.5525 4.15866 12.8458 4.15866C13.1625 4.15866 13.5071 4.09707 13.8796 3.9739C14.2521 3.85072 14.5747 3.71289 14.8474 3.56038C15.1201 3.40788 15.3782 3.27004 15.6216 3.14687C15.8651 3.02369 16.0249 2.96211 16.1011 2.96211C16.2536 2.96211 16.3856 3.01783 16.4971 3.12927C16.6085 3.24072 16.6642 3.37269 16.6642 3.52519Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_2352_17151">
            <rect
              width="15.7664"
              height="15.7664"
              fill="white"
              transform="translate(0.898438 0.710938)"
            />
          </clipPath>
        </defs>
      </svg>
    )
  }
  